namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_card, {
		
		flex: {
			direction: 'column',
		},
		gap: $mol_gap.block,
		padding: $mol_gap.block,
		border: {
			radius: $mol_gap.round,
		},
		background: {
			color: $mol_theme.card,
		},
		box: {
			shadow: [{
				x: 0,
				y: 0,
				blur: 0,
				spread: '1px',
				color: $mol_theme.line,
			}],
		},
		
		Title: {
			font: {
				size: '1.125rem',
				weight: 600,
			},
			margin: 0,
		},
		
		Body: {
			flex: {
				direction: 'column',
			},
			gap: $mol_gap.text,
		},
		
	} )
	
}
